// extracted by mini-css-extract-plugin
export default {"text":"UserSearch_text__SwZiz","subtitle":"UserSearch_subtitle__MxXoL"};